import { useTranslation } from "react-i18next"
import { Link, useParams } from "react-router-dom";
import { displayNameByLocale } from "./locales/locales";


export function getNavigatorLocale() {
  if (navigator.languages !== undefined) 
    return navigator.languages[0]; 
  return navigator.language;
}

export default function FlyerLocalePicker() {
  const { t, i18n } = useTranslation();
  const { flyerType } = useParams();

  const lang = i18n.language.slice(0, 2);
  const navigatorLocale = getNavigatorLocale();
  const country = navigatorLocale.length >= 5 ? navigatorLocale.slice(-2) : null;
  const locale = `${lang}_${country}`;

  const entries = Object.entries(displayNameByLocale);
  const highPri = [
    ...entries.filter(([key, _]) => key === locale),
    ...entries.filter(([key, _]) => key !== locale && key.startsWith(lang)),
    ...entries.filter(([key, _]) => key !== locale && key.endsWith(country)),
  ];
  const lowPri = [
    ...entries.filter((e) => !highPri.includes(e))
  ];

  return (
    <div className="generic-page">
      <div className="narrow-content flyer-locale-picker-container">
        <h1>{t('flyer-locale-picker.title')}</h1>
        <div style={{marginBottom: "10px"}}>
          {highPri.map(([key, value]) => (
            <Link to={`../editor/${flyerType}/${key}`} key={key}>
              {value}
            </Link>
          ))}
        </div>
        <div>
          {lowPri.map(([key, value]) => (
            <Link to={`../editor/${flyerType}/${key}`} key={key}>
              {value}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}